enum InternalMessagingTypes {
    SELECT_CONVERSATION = 'SELECT_CONVERSATION',
    NEW_MESSAGE_NOTIFICATION = 'NEW_MESSAGE_NOTIFICATION',
    OPEN_PHONEBOOK = 'OPEN_PHONEBOOK',
}

export default InternalMessagingTypes;